import React, { useState, useEffect, useRef, useCallback } from 'react';
import Logo from "../images/logo.svg";
import Select from 'react-select';
import Sidebar from '../component/Sidebar';
import { SelectPicker, Placeholder, Message, Whisper, Tooltip, Popover, Button, Modal, DatePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { Link, useNavigate } from "react-router-dom";
import * as bootstrap from 'bootstrap';
import { ReactComponent as IconStarOutline } from "../images/star-outline.svg";
import { ReactComponent as IconStar } from "../images/IconStar.svg";
import debounce from 'lodash.debounce';
import IconInfo from "../images/IconErrorInfo.svg";
import IconError from "../images/IconError.svg";
import IconCheckError from "../images/IconCheckError.svg";
import LogoKenvue from "../images/logo-kenvue.svg";
import LogoTesla from "../images/LogoTesla.svg";
import LogoApple from "../images/LogoApple.svg";
import LogoJNJ from "../images/jnj.svg";
import Icon_info from "../images/iconInfo.svg";

import 'aos/dist/aos.css';
import AOS from 'aos';
import { Center } from '@chakra-ui/react';
import { ChakraProvider, useToast, Wrap } from '@chakra-ui/react'
import moment from 'moment-timezone';

function ListingIPO() {
    const [tabName, setTabName] = useState('IPO Companies');
    useEffect(() => {
        document.title = tabName;
    }, [tabName]);

         const toast = useToast()
         const toastIdRef = React.useRef()

    useEffect(() => {
        AOS.init();
    }, []);
    const timeZone = 'Asia/Kolkata';

    const [isLoading, setLoading] = useState(true); // State to manage loading state
    const [isDeleteLoading, setDeleteLoading] = useState(false); // State to manage loading state
    const navigate = useNavigate();
    const apiEndPoint = process.env.REACT_APP_API_IPO_ENDPOINT;
    const apiEndPoint1 = process.env.REACT_APP_API_ENDPOINT;

    const frontEndLink = process.env.REACT_APP_MUSAFFA_LINK;
    const roleName = localStorage.getItem("novaRolename");
    const merlinJuniorAnalyst = process.env.REACT_APP_MERLIN_JUNIOR_ANALYST;
    const abortControllerRef = useRef(null);

    const [EditModalOpen, setEditModalOpen] = useState(false);
    const [editModalIPOName, setEditModalIPOName] = useState("");
    
    const [reportData, setReportData] = useState([]);
    const [reportCount, setReportCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [startPage, setStartPage] = useState(1);
    const [countryCode, setCountryCode] = useState("");
    const [complianceId, setComplianceId] = useState("");
    const [statusId, setStatusId] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [pageRange, setPageRange] = useState("20");

    const [countryData, setCountryData] = useState([]);
    const [complianceData, setComplianceData] = useState([]);
    const [statusData, setStatusData] = useState([]);
    const [ratingData, setRatingData] = useState([]);
    const [selectedQuarter, setSelectedQuarter] = useState("");

    const userid = localStorage.getItem("novauserid");
    const progressStatus = process.env.REACT_APP_TASK_MANAGER_PROGRESS_Status;


    const [errorMessage, setErrorMessage] = useState('');
    const [messageType, setMessageType] = useState(null); // success, error, info
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);


    const [withdrawDate, setWithdrawDate] = useState('');
    const [priceDate, setPriceDate] = useState('');
    const [price, setPrice] = useState('');

    const handleQuaterChange = (selectedOption) => {
        setSelectedQuarter(selectedOption); // Update selectedPeriod state with the selected option
    };

    //Country List
    useEffect(() => {
        const fetchCountryList = async () => {
            const url = ` ${apiEndPoint}/ipo_country_list`;
            const payload = {
                data: {
                    user_id: userid // Replace with the actual user_id if dynamic
                }
            };

            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const responseData = await response.json();
                const data = responseData.data; // Flatten the response

                const formattedCountryData = data.data.map((country) => ({
                    label: country.country_name,
                    value: country.country_code,
                }));

                setCountryData(formattedCountryData);

            } catch (error) {
                console.log(error);
            }
        };

        fetchCountryList();
    }, []);

    // Compliance List
    useEffect(() => {
        const fetchComplianceStatusList = async () => {
            const url = `${apiEndPoint}/ipo_sharia_status`;
            const payload = {
                data: {
                    user_id: userid // Replace with the actual user_id if dynamic
                }
            };

            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const responseData = await response.json();
                const data = responseData.data; // Flatten the response

                const formattedComplianceStatusData = data.data.map((complaince) => ({
                    label: complaince.status,
                    value: complaince.status,
                }));

                setComplianceData(formattedComplianceStatusData);

            } catch (error) {
                console.log(error);
            }
        };

        fetchComplianceStatusList();
    }, []);

    //Status List
    useEffect(() => {
        const fetchStatusList = async () => {
            const url = `${apiEndPoint}/ipo_status`;
            const payload = {
                data: {
                    user_id: userid // Replace with the actual user_id if dynamic
                }
            };

            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const responseData = await response.json();
                const data = responseData.data; // Flatten the response

                const formattedStatusData = data.data.map((status) => ({
                    label: status.ipo_status,
                    value: status.ipo_status,
                }));

                setStatusData(formattedStatusData);

            } catch (error) {
                console.log(error);
            }
        };

        fetchStatusList();
    }, []);

    useEffect(() => {
        const fetchStatusList = async () => {
            const url = `${apiEndPoint}/ipo_rating`;
            const payload = {
                data: {
                    user_id: userid // Replace with the actual user_id if dynamic
                }
            };

            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const responseData = await response.json();
                const data = responseData.data; // Flatten the response

                const formattedStatusData = data.data.map((status) => ({
                    label: status.rating,
                    value: status.rating,
                }));

                setRatingData(formattedStatusData);

            } catch (error) {
                console.log(error);
            }
        };

        fetchStatusList();
    }, []);


    const fetchGlobalReport = async () => {
        setLoading(true);

        // Cancel the previous request if any
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        // Create a new AbortController for the current request
        const controller = new AbortController();
        abortControllerRef.current = controller;

        try {
            const apiUrl = `${apiEndPoint}/get_all_ipo`;
            const requestData = {
                data: {
                   // user_id: userid,
                    limit: pageRange,
                    page: currentPage.toString(),
                    q: searchInput,
                    country: countryCode,
                   // AAOIFI_status: complianceId,
                    rating:statusId,
                    shariaStatus: complianceId,
                }
            };
            console.log(JSON.stringify(requestData));
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestData),
                signal: controller.signal
            });

            const jsonData = await response.json();
            const { status, message, count, data } = jsonData.data;
            if (status == "success") {
                setLoading(false);
                setReportCount(count);
                console.log('RES :' + count + ' : ' + JSON.stringify(data));
                setReportData(data);
            } else {
                console.error("Error: ", message);
            }
        } catch (error) {
            if (error.name === "AbortError") {
                console.log("Request cancelled");
            }
            else {
                console.error("Error fetching data:", error.message);
            }
            return false;
        }
    };

   const debouncedFetchGlobalReport = useCallback(
       debounce(() => {
         fetchGlobalReport();
       }, 500),
       [searchInput] // Only debounce on search input changes
     );
   
     useEffect(() => {
       debouncedFetchGlobalReport();
       return () => {
         debouncedFetchGlobalReport.cancel();
       };
     }, [searchInput]);
   
     useEffect(() => {
       fetchGlobalReport();
     }, [currentPage, countryCode, complianceId, statusId,pageRange]); // Regular effect for other dependencies
   


    const data2 = [
        { label: "Q1", value: 1 },
        { label: "Q2", value: 2 },
        { label: "Q3", value: 3 },
        { label: "Q4", value: 4 },
    ];

    const ReportSourceData = [
        { label: "2022", value: 1 },
        { label: "2023", value: 2 },
        { label: "2024", value: 3 },
        { label: "2025", value: 4 },
    ];


    const handleSearch = (event) => {
        console.log(event.target.value);

        setSearchInput(event.target.value);
        setCurrentPage(1); // Reset to the first page for new search
    };


    const handleCountryChange = (value) => {
        setCountryCode(value);
    };

    const handleComplianceChange = (value) => {
        setComplianceId(value);
    };

    const handleStatusChange = (value) => {
        setStatusId(value);
    };



   
const handleAddNewReport = async() => {
 
    // const reportSource = document.getElementById(`reportSource`).value;
     
     if(!reportSource)
     {
       setErrorMessage('Please Enter Report Year');
       setMessageType('error');
       return false;
     }
     if(!selectedQuarter)
     {
         setErrorMessage('Please Select Quater');
         setMessageType('error');
         return false;
     }
     
 
 
     const date = "";//The date is not Available on this uncovered stock API 
     const company_symbol = reportSymbol;
     const year = reportSource;
     const quarter = selectedQuarter;
     const taskCheckSuccess = await checkTask(company_symbol, reportSource, selectedQuarter);
     if (taskCheckSuccess) {
       const cancelButton = document.getElementById(`CancelReport`);
       if (cancelButton) {
         cancelButton.click();
       }
       await updateReportStatus(userid, company_symbol, date, quarter, year);
     }
   
 };

    const checkTask = async (selectedCompany, reportSource, selectedQuarter) => {
        try {
            const res = await fetch(`${apiEndPoint1}/check_task`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    data: {
                        user_id: userid,
                        company_symbol: selectedCompany,
                        quarter: selectedQuarter,
                        year: reportSource,
                        is_ipo:1,
                    },
                }),
            });

            const result = await res.json();

            if (result.data.status === 'Success') {
                // setErrorMessage(result.data.message);
                // setMessageType('success');
                // return false;
                return true;
            } else {
                setErrorMessage(result.data.message);
                setMessageType('error');
                return false;
            }
        } catch (err) {
            console.log('Check Report : Error : ' + err.message);
            setErrorMessage('An error occurred while checking the task');
            setMessageType('error');
            return false; // Indicate failure
        }
    };


    const updateReportStatus = async (userid, company_symbol, date, quarter, year, companyId) => {
        const url = `${apiEndPoint1}/update_tasks`;

        const payload = {
            data: {
                user_id: userid, // Replace this with the actual user_id if dynamic
                company_symbol: company_symbol, // Assuming itemId represents company_symbol
                date: date, // Replace this with the actual date if dynamic
                quarter: quarter, // Replace this with the actual quarter if dynamic
                year: year, // Replace this with the actual year if dynamic
                status: progressStatus,
                is_ipo: 1
            }
        };

        //console.log(JSON.stringify(payload));
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const responseData = await response.json();
            const data = responseData.data; // Flatten the response
            if (data.status === "success") {
                //window.open(`/report/ancasdasdas`, '_blank');

                navigate(`/report/${data.data.encryptJSON}`);
                //
                return true; // Indicate success
            } else {
                console.error("API Error:", data.data.message);
                return false; // Indicate failure
            }
        } catch (error) {
            console.error("API Error:", error);
            return false; // Indicate failure
        }
    };


    const [customPaginationValue, setCustomPaginationValue] = useState("");

    // Debounced function to update the page number
    const debouncedSetPage = useCallback(
        debounce((page) => {
            setCurrentPage(page);
        }, 500), // Delay of 500ms (half a second)
        []
    );

    const handlePaginationChange = (e) => {
        const value = (e.target.value == 0 ? 1 : e.target.value).toString();
        setCustomPaginationValue(value); // Update input value immediately for fast typing
        debouncedSetPage(Number(value)); // Trigger the debounced function
    };

    const handlePagelimit = (value) => {
        setCurrentPage(1);
        setCustomPaginationValue(1);
        setPageRange(value);
    };


    const renderPagination = () => {
        // Calculate total number of pages
        const totalPages = Math.ceil(reportCount / pageRange);

        // Show a default of 3 pages if the total pages are more than 3
        const pageNumbers = [];
        const visiblePageCount = 4; // Number of pages to show by default

        let startPage = currentPage - 1;
        let endPage = currentPage + 2;

        // Adjust pagination if total pages are less than the default
        if (totalPages <= visiblePageCount) {
            startPage = 1;
            endPage = totalPages;

        } else {

            // Ensure the pagination does not go out of bounds
            startPage = Math.max(1, startPage);
            endPage = Math.min(totalPages, endPage);
        }

        // Create page numbers to display based on current page
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }

        return (
            <nav aria-label="..." id='pagination_row' style={{ alignItems: 'center', justifyContent: 'space-between', background: '#FFF', paddingTop: 0, paddingBottom: 0 }}>
                <div className='totalRecords'>
                    Total Records :  {Number(reportCount).toLocaleString()}
                </div>
                <ul className="pagination" style={{ border: 0, background: 'none' }}>

                    <li class="page-item" style={{ marginLeft: 10 }}>
                        <SelectPicker onChange={handlePagelimit} cleanable={false}
                            value={pageRange}
                            placement="top" placeholder='Pages' data={PagingData} searchable={false} style={{ width: 85, height: 35, display: 'flex', alignItems: 'center', borderRadius: 5, border: '1px solid #A1B9ED' }} />
                    </li>

                    {/* Previous Page (Double Arrow) */}
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`} style={{ marginLeft: 10 }}>
                        <a href="#" className="page-link" onClick={() => setCurrentPage(1)}>
                            <i className="fa fa-angle-double-left"></i>
                        </a>
                    </li>

                    {/* Previous Page (Single Arrow) */}
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <a href="#" className="page-link" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}>
                            <i className="fa fa-angle-left"></i>
                        </a>
                    </li>

                    {/* Page numbers */}
                    {pageNumbers.map(page => (
                        <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                            <a
                                className="page-link" href="#"
                                onClick={() => setCurrentPage(page)} // Set the clicked page as the current page
                            >
                                {page}
                            </a>
                        </li>
                    ))}

                    {/* Next Page (Single Arrow) */}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <a href="#" className="page-link" onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}>
                            <i className="fa fa-angle-right"></i>
                        </a>
                    </li>

                    {/* Next Page (Double Arrow) */}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`} style={{ marginRight: 10 }}>
                        <a href="#" className="page-link" onClick={() => setCurrentPage(totalPages)}>
                            <i className="fa fa-angle-double-right"></i>
                        </a>
                    </li>

                    {/* Go to Page */}
                    <li className="page-item" style={{ marginLeft: 10, display: 'flex', alignItems: 'center', gap: 5 }}>
                        <input
                            type="text"
                            placeholder="Go#"
                            className="form-control"
                            value={customPaginationValue}
                            onChange={handlePaginationChange}
                            onInput={(e) => {
                                // Only allow numbers
                                e.target.value = e.target.value.replace(/[^0-9]/g, '');
                            }}

                            style={{
                                padding: '0px 10px',
                                color: '#878787',
                                fontSize: 16,
                                borderRadius: 5,
                                border: '1px solid #A1B9ED',
                                width: 60,
                                height: 35,
                                textAlign: 'center'
                            }}
                        />
                    </li>
                </ul>
            </nav>
        );
    };





    // PAGINATION
    const PagingData = ['10', '20', '50', '100'].map(
        item => ({ label: item, value: item })
    );



    const handleClearFilters = () => {
        setCurrentPage(1);
        setCountryCode("");
        setSearchInput("");
        setComplianceId("");
        setStatusId("");
    };


    const renderStars = (ranking) => {
        const fullStars = Math.floor(ranking);
        const stars = [];
        for (let i = 0; i < 5; i++) {
            if (i < fullStars) {
                stars.push(<li key={i}><IconStar /></li>);
            } else {
                stars.push(<li key={i}><IconStarOutline /></li>);
            }
        }
        return stars;
    };

    const hideMessage = () => {
        setMessageType(null);
    };

    const renderMessage = () => {
        if (messageType) {
            setTimeout(hideMessage, 4000);
        };

        switch (messageType) {
            case 'success':
                return (
                    <Message type="success" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: "fixed", right: 10, top: 10, zIndex: 99999 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                            <div className='icon_error_msg Icon_success'>
                                <div className='icon_error_msg_inner Icon_success_inner'>
                                    <img src={IconCheckError} alt="Success Icon" />
                                    <div className="progress-circle progress_circle_success"></div>
                                </div>
                            </div>
                            <div className='error_msg_text error_msg_success_text'>
                                <h5>Success</h5>
                                <p>{errorMessage}</p>
                            </div>
                        </div>
                    </Message>
                );
            case 'error':
                return (
                    <Message type="error" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: "fixed", right: 10, top: 10, zIndex: 99999 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                            <div className='icon_error_msg Icon_error'>
                                <div className='icon_error_msg_inner Icon_error_inner'>
                                    <img src={IconError} alt="Error Icon" />
                                    <div className="progress-circle progress_circle_error"></div>
                                </div>
                            </div>
                            <div className='error_msg_text error_msg_error_text'>
                                <h5>Error</h5>
                                <p>{errorMessage}</p>
                            </div>
                        </div>
                    </Message>
                );
            case 'info':
                return (
                    <Message type="info" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position: "fixed", right: 10, top: 10, zIndex: 99999 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                            <div className='icon_error_msg Icon_info'>
                                <div className='icon_error_msg_inner Icon_info_inner'>
                                    <img src={IconInfo} alt="Info Icon" />
                                    <div className="progress-circle progress_circle_info"></div>
                                </div>
                            </div>
                            <div className='error_msg_text error_msg_info_text'>
                                <h5>Info</h5>
                                <p>No reports found for the selected priority</p>
                            </div>
                        </div>
                    </Message>
                );
            default:
                return null;
        }
    };



    const [openStatusPopover, setOpenStatusPopover] = useState(null);
    const [publishSymbol, setPublishSymbol] = useState("");
    // Function to handle checkbox click
    const handleCheckboxClick = (item) => {
        // Toggle the popover visibility for the specific item
        setPublishSymbol(item.company_symbol)
        if (openStatusPopover === item.id) {
            setOpenStatusPopover(null); // Close the popover if it's already open
        } else {
            setOpenStatusPopover(item.id); // Open the popover
        }
    };

    // Function to handle deletion confirmation
    const handlePublishConfirm = async (company) => {
        try {
            // Perform the API call
            const response = await fetch(`${apiEndPoint}/update_company_status`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    data: {
                        user_id: userid,
                        status: company.report_status ? '0' : '1',
                        symbol: company.company_symbol // Assuming 'company.symbol' holds the company symbol
                    }
                })
            });

            // Parse the response as JSON
            const result = await response.json();

            // Handle the response based on the status
            if (response.ok && result.data.status === 'success') {
                // Show success message
                console.log(result.data.message); // e.g., "Company status updated successfully"
                // Optionally, you can display a UI notification or message here
                fetchGlobalReport();
                // Close the popover after confirmation
                setOpenStatusPopover(null);

            } else {
                // Handle failure case (if any)
                console.error('Failed to update company status:', result.data.message || 'Unknown error');
                // Optionally, display an error message in the UI
            }
        } catch (error) {
            console.error('Error:', error);
            // Handle any network or unexpected errors
        }


    };


    const handleCheckboxChange = (e, item) => {
        setPublishSymbol(item.company_symbol)
        //e.stopPropagation(); // Prevents the event from bubbling up
        // Handle the checkbox change here
        // You can check e.target.checked to see if it's checked or unchecked
    };

    const [selectedStatus, setSelectedStatus] = useState(0);
    const [id, setId] = useState("");
    const [ipoComment, setipoComment] = useState("");
    const [ipoCountry, setIpoCountry] = useState("");

    const handleETFStatusChange = (selectedOption) => {
        setSelectedStatus(selectedOption); // Update selectedPeriod state with the selected option
    };

    // const [open, setOpen] = useState(false);
    const handleEditModalOpen = (item) => {
       
        setEditModalIPOName(item.name);
        setSelectedStatus(item.status);
        setId(item.id);
        setipoComment(item.ipo_comment);
        setIpoCountry(item.country);
        setPrice("");
        setPriceDate('');
        setWithdrawDate('');

        if(item.status == "Priced")
        {
            setPrice(item.priced_price);
            setPriceDate(new Date(item.priced_date));
        }

        if(item.status == "Withdrawn"){
            setWithdrawDate(item.withdraw_date ? new Date(item.withdraw_date) : '');
        }

        // if(item.is_manual_set === "1")
        // {g
        //   setSelectedStatus(item.Compliance_status);
        //   // Update the textarea's value
        //   setEtfModelPublicComment(item.manual_public_msg || "");
        //   setEtfModelPrivateComment(item.is_manual_set_msg || "");
        // }
        // else{
        //   setSelectedStatus("");
        //   setEtfModelPublicComment(""); // Clear the comment if not manual set
        //   setEtfModelPrivateComment("");
        // }
        
        setEditModalOpen(true);
      }
      const handleEditModalClose = () => setEditModalOpen(false);
    
    const [reportName, setReportName] = useState("");
    const [reportSymbol, setReportSymbol] = useState("");
  const [reportSource, setReportSource] = useState('');

      const handleReportData = async(item) => {
        setReportName(item.name);
        setReportSymbol(item.symbol);
      };

      const handleChange = (e) => {
        const value = e.target.value;
      
        // Check if the value is a number and does not exceed 4 digits
        if (/^\d{0,4}$/.test(value)) {
          setReportSource(value); // Update state only if the value is valid
        }
      };

      const handleCancelReport = async(item) => {
        setSelectedQuarter("");
        setReportSource("");
      };

      const handleManualReset = async () => {


        // setIsModalETFLoading(true);
      
        // const apiUrl = `${apiEndPoint}/set_etf_status_manually`;
        // const requestBody = {
        //   data: {
        //     public_message:"",
        //     message: "",
        //     sharia_status: "",
        //     etf_symbol: editModalETFSymbol,
        //     is_manual_set: "0",
        //   },
        // };
      
      
        // try {
        //   const response = await fetch(apiUrl, {
        //     method: "POST",
        //     headers: {
        //       "Content-Type": "application/json",
        //     },
        //     body: JSON.stringify(requestBody),
        //   });
      
        //   if (response.ok) {
        //     const result = await response.json();
        //     console.log("API Response:", result);
      
        //     if (result.data.status === "success") {
        //       setIsModalETFLoading(false);
        
        //       setEditModalOpen(false);
        //       setErrorMessage(result.data.message);
        //       setMessageType('success');
        //       fetchGlobalReport(); // Call fetchGlobalReport when status is success
      
              
        //     } else {
        //       setIsModalETFLoading(false);
        //       console.error("Save failed. Message:", result.data.message);
        //       alert(`Save failed: ${result.data.message}`);
        //     }
        //   } else {
        //     setIsModalETFLoading(false);
        //     console.error("Failed to save. Status:", response.status);
        //     alert("Save failed!");
        //   }
        // } catch (error) {
        //   setIsModalETFLoading(false);
        //   console.error("Error while saving:", error);
        //   alert("An error occurred!");
        // }
      };
      
      const handleManualSave = async (status) => {

        let apiUrl = "";
        let requestBody = {};
        


        if (status === 'reset') {
             apiUrl = `${apiEndPoint}/update_ipo_status`;

         requestBody = {
          data: {
            id: id,
            status: "Upcoming",
            ipo_comment: "",
            withdraw_date:"",
            priced_date:"",
            price:"",
          },
        };
          } else if (status === 'save') {
          
            const withdrawDate1 = moment(withdrawDate).tz(timeZone).format();
            const priceDate1 = moment(priceDate).tz(timeZone).format();
         
        let hasError = false;
        if (!selectedStatus) {
          toastIdRef.current = toast({ description: "Please select new compliance status", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
          hasError = true;
        }

        if (selectedStatus === "Withdrawn" && !withdrawDate) {            
                toastIdRef.current = toast({ description: "Please Add Withdraw Date", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
                hasError = true;
        };

        if (selectedStatus === "Priced" && !price) {            
            toastIdRef.current = toast({ description: "Please Add Price", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
            hasError = true;
        };

        if (selectedStatus === "Priced" && !priceDate) {            
            toastIdRef.current = toast({ description: `Please Add ${ipoCountry == "IN" ? "Listing" : ""} Date`, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
            hasError = true;
        };
      
        if (!ipoComment) {
          toastIdRef.current = toast({ description: "Please add comment", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
          hasError = true;
        }

        if (!hasError) {
         apiUrl = `${apiEndPoint}/update_ipo_status`;
         requestBody = {
          data: {
            id: id,
            status: selectedStatus,
            ipo_comment: ipoComment,
            ...(selectedStatus === "Withdrawn" && { withdraw_date: withdrawDate1 }),
            ...(selectedStatus === "Priced" && { priced_date: priceDate1, price: price })
          },
        };


      
        try {
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          });
      
          if (response.ok) {
            const result = await response.json();
            console.log("API Response:", result);
      
            if (result.data.status === "success") {
              
                toastIdRef.current = toast({ description: result.data.message, status: 'success', duration: 5000, isClosable: true, position: 'bottom', });
                setEditModalOpen(false);
              fetchGlobalReport(); // Call fetchGlobalReport when status is success
      
            } else {
              console.error("Save failed. Message:", result.data.message);
              toastIdRef.current = toast({ description: result.data.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
            }
          } else {
            console.error("Failed to save. Status:", response.status);
            toastIdRef.current = toast({ description: response.status, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
          }
        } catch (error) {
          console.error("Error while saving:", error);
          toastIdRef.current = toast({ description: error.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
        }
    }
          }
      };

      
      const handleDeleteCancel = () => {
        setShowModal(false);
    };
      const handleDelete = () => {

        setDeleteLoading(true);
        const payload = {
          data: {
            id: selectedId // Change to dynamic ID if needed
          }
        };
      
        fetch(`${apiEndPoint}/delete_ipo`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
          .then(response => response.json())
          .then(result => {
            if (result?.data?.status === "success") {
                setDeleteLoading(false);
                setShowModal(false);
                setTimeout(() => {
                    fetchGlobalReport();
                }, 2000); // Delay of 1 second (1000 ms
                

                toastIdRef.current = toast({ description: result?.data?.message, status: 'success', duration: 5000, isClosable: true, position: 'bottom', });
            } else {
                setDeleteLoading(false);
                
                toastIdRef.current = toast({ description: result?.data?.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
            }
          })
          .catch(error => {
            setDeleteLoading(false);
            setShowModal(false);
            fetchGlobalReport();
            toastIdRef.current = toast({ description: error.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
          });
      };
      
      

      const openDeleteModal = (id) => {
        setSelectedId(id);

             setShowModal(true);
      };

      function CustomCaretIcon() {
        return <i className='icon-calendar'></i>;
    }

    return (
        <>
            <Sidebar />
            <div id='header'>
                <div className='logo'>
                    <div className='logo_icon'>
                        <img src={Logo} alt="Logo" />
                    </div>
                    <div className='brand_name'>IPO Calendar</div>
                </div>

                <div className='header_table_filter'>
                    <div className='searchfield'>
                        <button className='btn_search'><i className='icon-search2'></i></button>
                        <input type='text' className='filter_searchfield' placeholder='Search' autocomplete="off" onChange={handleSearch} value={searchInput} />
                    </div>

                    <div className='dropdown_col_filter dropdown__select'>
                        <SelectPicker
                            data={ratingData}
                            searchable={false}
                            style={{ width: 160 }}
                            placeholder="Halal Ratings"
                            onChange={handleStatusChange}
                            value={statusId}
                        />
                    </div>

                    <div className='dropdown_col_filter dropdown__select'>
                        <SelectPicker
                            data={complianceData}
                            searchable={false}
                            style={{ width: 220 }}
                            placeholder="All Compliance Statuses"
                            onChange={handleComplianceChange}
                            value={complianceId}
                        />
                    </div>

                    <div className='dropdown_col_filter dropdown__select'>
                        <SelectPicker
                            data={countryData}
                            searchable={false}
                            style={{ width: 170 }}
                            placeholder="All Countries"
                            onChange={handleCountryChange}
                            value={countryCode}
                        />

                    </div>

                    <a href="javascript:void(0)" className="btn_clear_filter" style={{ textDecoration: "none" }} onClick={handleClearFilters}>
                        Clear Filters
                    </a>
                </div>
                <div className='header_monthly_value'>
                    <Link to='/registeripo' className='btn_add_new'><i className='icon-plus2'></i>Add Pre- IPO</Link>
                </div>
            </div>
            <div className="container-fluid content pb-5">
                <div className='company_table_list'>
                    {isLoading && (<Placeholder.Grid rows={20} columns={9} active style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }} />)}

                    {/* Table */}
                    {!isLoading && (
                        <>
                            <div className='table-responsive clsPagingWrap' >
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th style={{ textAlign: 'center' }}>IPO Status</th>
                                            <th style={{ textAlign: 'center' }}>Compliance</th>
                                            <th style={{ textAlign: 'center' }}>Halal Ratings</th>
                                            <th style={{ textAlign: 'right' }}>Price Range</th>
                                            <th style={{ textAlign: 'right' }}>Shares Offered</th>
                                            <th style={{ textAlign: 'right' }}>Offer amount</th>
                                            <th style={{ textAlign: 'center' }}>Expected IPO Date</th>
                                            <th style={{ textAlign: 'center' }}>Issue Opening Date</th>
                                            <th style={{ textAlign: 'center' }}>Issue Closing Date</th>
                                            <th>Country</th>
                                            <th style={{ textAlign: 'center' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {reportData.length > 0 ? (
                                                reportData.map((item, index) => (
                                                    <>
                                        <tr>
                                            <td>
                                                <div className='company_name_td'>
                                                    <div className="clogo">
                                                        <img src={item.logo} />
                                                    </div>
                                                    <span className='company_tag' style={{ width: 100 }}
>
                                                    {item.symbol}
                                                    </span>
                                                    <span className='company__name'>{item.name}</span>
                                                </div>
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                <span className='ipo__status' onClick={() => handleEditModalOpen(item)}>{item.status}</span>
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                <span className={`tag_td ${ item.shariaStatus2 == "0" || item.shariaStatus2 == null ? '' : item.shariaStatus2 == "COMPLIANT" ? 'halal_tag' : item.shariaStatus2 == "NON_COMPLIANT" ? 'not_halal_tag' : item.shariaStatus2 == "QUESTIONABLE" ? 'doughtful_tag' : item.shariaStatus2 == "UCVD" ? 'uncover_tag' : ' ' }`}>{item.shariaStatus}</span>
                                            </td>
                                            <td style={{ textAlign: 'center' }}>{item.rating}</td>
                                            <td style={{ textAlign: 'right' }}>
                                                <div className='price__range'>{item.price}</div>
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                <div className='price__range'>{item.numberOfShares}</div>
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                <div className='price__range'>{item.totalSharesValue}</div>
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                <div className='price__range'>{item.ipo_date}</div>
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                <div className='price__range'>{item.ipo_open_date}</div>
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                <div className='price__range'>{item.ipo_close_date}</div>
                                            </td>
                                            <td style={{}}>
                                                <div className='price__range'>{item.country}</div>
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                <div class="action___row">
                                                    {item.name || item.symbol ? (
                                                                          <h5> <Link className='btn_create_report' data-bs-toggle="modal" data-bs-target={`#CreateReportModal`} onClick={() => handleReportData(item)}> Create Report </Link> </h5>  
                                                    ) : ("")}

                                                    <Link to="/registeripo" state={{ id: item.id }} class="btn_icon_action btn__edit__circle" href="javascript:avoid:(0);" ><i class="icon-edit"></i></Link>
                                                    <Link class="btn_icon_action btn__delete__circle" href="javascript:avoid(0);"   onClick={() => openDeleteModal(item.id)}  ><i className='icon-delete'></i></Link>

                                                </div>
                                            </td>
                                        </tr>
                                      
                                        </>
                                     ))
                                        ) : (
                                            <tr>
                                            <td colSpan="9" style={{ textAlign: "center" }}>
                                                No data available
                                            </td>
                                            </tr>
                                        )}                  


                                    </tbody>
                                </table>
                            </div>

                            {reportCount > 0 && renderPagination()}

                        </>
                    )}
                </div>
            </div>

            {/* Delete Modal */}

            {showModal && (
           <div className={`modal fade report_delete_modals ${showModal ? "show d-block" : ""}`}  tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body">
                            <h5>Are you sure you want to delete the<br />selected Pre-IPO Companies?</h5>
                            <p>This action cannot be undone. Deleted companies will<br /> be permanently removed from the listing</p>
                            <div class="btn__group mt-5" style={{}}>
                                <Button type="button" className="btn__cancel" onClick={handleDeleteCancel}>Cancel</Button>
                                <ChakraProvider>
                                <Button type="button" className="btn__assign" onClick={handleDelete} loading={isDeleteLoading}>Delete</Button>
                                </ChakraProvider>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            )}
            {/* Modals */}

            <Modal open={EditModalOpen} onClose={() => handleEditModalClose(false)} className="edit_status_modal">
                <Modal.Header className="edit_modal_header">
                    <Modal.Title className="edit_modal_title">{editModalIPOName}</Modal.Title>
                    <p>Manually Update the IPO Status</p>
                </Modal.Header>

                <Modal.Body>
                    <div className="edit_modal_content">
                        <div className="edit_status_field">
                            <label style={{gap:0}}>Select IPO Status<span className='star_red'>*</span></label>
                            <div className="select_edit_status">
                                <SelectPicker
                                    data={statusData}
                                    searchable={false}
                                    style={{ width: '100%' }}
                                    placeholder="Select the new IPO status"
                                    onChange={handleETFStatusChange} // Attach onChange event handler
                                    value={selectedStatus} // Set the value prop to control the selected value
                                />
                            </div>
                        </div>

                        {selectedStatus == "Withdrawn" && (

                        <div className="edit_status_field mt-4">
                            <label style={{gap:0}}>Date<span className='star_red'>*</span></label>
                            <div className='form_datepicker modalDatePicker' > <DatePicker oneTap style={{ width: "100%" }}  placeholder="DD/MM/YYYY" caretAs={CustomCaretIcon} value={withdrawDate} onChange={(date) => setWithdrawDate(date)} />
                            </div>
                        </div>
                        )}

                        {selectedStatus == "Priced" && (
<>
                        <div className='row'>
                        <div className='col-sm-6'>
                        <div className="edit_status_field mt-4">
                            <label style={{gap:0}}>Price<span className='star_red'>*</span></label>
                            <input type='number' className='form-control' placeholder='Price' value={price} onChange={(e) => setPrice(e.target.value)} style={{height:46}} />
                        </div>
                        </div>
                        <div className='col-sm-6'>
                        <div className="edit_status_field mt-4">
                        <label style={{gap:0}}>{ipoCountry == "IN" ? "Listing" : ""} Date<span className='star_red'>*</span></label>
                        <div className='form_datepicker modalDatePicker'> 
                            <DatePicker oneTap style={{ width: "100%", height:46 }} placement="bottom" placeholder="DD/MM/YYYY" 
                        caretAs={CustomCaretIcon} value={priceDate} onChange={(date) => setPriceDate(date)}/>
                        </div>
                        </div>
                        </div>
                        </div>
                        </>
                        )}



                        <div className="edit_status_field mt-4">
                            <label style={{gap:0}}>Comment<span className='star_red'>*</span> 
                            </label>
                            <textarea row="3" className="form-control"  value={ipoComment} onChange={(e) => setipoComment(e.target.value)}></textarea>
                        </div>

                        {/* <div className="edit_status_field mt-4">
                            <label>Private Comment
                                <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>This is an internal comment visible only to the analyst team. Use this space to provide insights, notes, or clarifications for internal review</Tooltip>}>
                                    <img src={Icon_info} />
                                </Whisper>
                            </label>
                            <textarea row="3" className="form-control"></textarea>
                        </div> */}
                    </div>
                </Modal.Body>
                <Modal.Footer className="modal_footer_edit_status">
                    <div className="btn__group">
                        <button type="button" className="btn_cancel" onClick={handleEditModalClose}>Cancel</button>
                        {/* <Button className="btn___reset"onClick={() => handleManualSave('reset')}>Reset</Button> */}
                        <ChakraProvider>
                        <Button className="btn__save" onClick={() => handleManualSave('save')} style={{marginLeft:0}}>Save</Button>
                        </ChakraProvider>
                    </div>
                </Modal.Footer>
            </Modal>

                  {/* Modal */}
                <div className="modal fade duplicate_form_modal" id={`CreateReportModal`} tabIndex="-1" aria-labelledby={`DuplicateFormModalLabel`} aria-hidden="true">
                {renderMessage()}
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h1 className="modal-title fs-5">{reportName}</h1>
                      </div>
                      <div className="modal-body">
                        <div className='duplicate_form_content'>
                          <div className='duplicate_form_row'>
                            <div className='duplicate_form_col'>
                              <label>Report Source</label>
                              {/* <input type='text' id={`reportSource_${item.row_id}`} className='form-control' placeholder='YYYY' /> */}
                              {/* <input type='text' id={`reportSource`} className='form-control' placeholder='YYYY' /> */}
                              <input maxLength={4}  type="text" id="reportSource" className='form-control' placeholder='YYYY'  value={reportSource} onChange={handleChange}
             />
                            </div>
            
                            <div className='duplicate_form_col'>
                              <label>Filling Type</label>
                              <div className='select_drop_picker'>
                                <SelectPicker
                                  data={data2}
                                  searchable={false}
                                  style={{ width: 250 }}
                                  placeholder="Quarter"
                                  onChange={handleQuaterChange}
                                  value={selectedQuarter}
                                />
                              </div>
                            </div>
                          </div>
            
                          <div className="btn__group">
                            {/* <button type="button" className="btn_cancel" data-bs-dismiss="modal" id={`Cancel_${item.row_id}`}>Cancel</button>
                            <button type="button" className="btn_duplicate btn_add_new_report" onClick={() => handleAddNewReport(item.row_id)}>Add New Report</button> */}
            
                            <button type="button" className="btn_cancel" data-bs-dismiss="modal" id={`CancelReport`} onClick={() => handleCancelReport()}>Cancel</button>
                            <button type="button" className="btn_duplicate btn_add_new_report" onClick={() => handleAddNewReport()}>Add New Report</button>
            
            
                            {/* <button type="button" className="btn_duplicate btn_add_new_report" onClick={() => handleAddNewReport(company.row_id)}>Add New Report</button> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* End Modal */}



        </>
    );
}

export default ListingIPO;

